import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { useReturnStore } from '../../stores/returnStore';
import ErrorOrderNumberBarcode from './ErrorOrderNumberBarcode';
var OrderNumberBarcode = function () {
    var orderDetailsV2 = useReturnStore(function (state) { return state.orderDetailsV2; });
    var orderBarcode = useReturnStore(function (state) { return state.orderBarcode; });
    var receiptNumber = useReturnStore(function (state) { return state.receiptNumber; });
    var imgSrc = 'data:image/png;base64,' + orderBarcode;
    var orderName = receiptNumber
        ? receiptNumber
            .split(' ')
            .map(function (part, position) {
            var _a, _b;
            return position !== 0
                ? part
                : ((_a = part.charAt(0)) === null || _a === void 0 ? void 0 : _a.toUpperCase()) + ((_b = part.slice(1)) === null || _b === void 0 ? void 0 : _b.toLowerCase());
        })
            .join(' ')
        : undefined;
    if (orderName && orderName.includes('#')) {
        var hashIndex = orderName.indexOf('#');
        if (orderName[hashIndex + 1] === ' ') {
            orderName =
                orderName.slice(0, hashIndex + 1) + orderName.slice(hashIndex + 2);
        }
    }
    if (!orderDetailsV2 || !orderBarcode) {
        return React.createElement(ErrorOrderNumberBarcode, { orderName: orderName });
    }
    return (React.createElement("div", { className: "sui-mb-8" },
        React.createElement("div", { className: "sui-mb-2" },
            React.createElement("img", { src: imgSrc, height: 30, width: 350, alt: "Barcode", className: "sui-h-[30px]" })),
        React.createElement(Typography, { height: "tight" }, orderName || "Order #".concat(orderDetailsV2 === null || orderDetailsV2 === void 0 ? void 0 : orderDetailsV2.orderNumber))));
};
export default OrderNumberBarcode;
